export { default } from './RadioInputWithImage';
